import { RootState } from "../reducers"

export const selectBridgeHistory = (state: RootState) => state.bridge.history

export const selectHasLoadedBridgeData = (state: RootState) =>
  state.bridge.hasLoadedBridgeData

export const selectLatestBridgeTransactions = (state: RootState) =>
  state.bridge.latestTransactions
